import styled from 'styled-components'
import { boxModel, css } from '../util'
import { boxModelTypes, cssTypes } from '../types'

/**
 * @namespace TableHeadCell
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const TableHeadCell = styled.th`
  ${boxModel};
  ${css};
`

/**
 * @name defaultProps
 * @memberof TableHeadCell
 * @desc Primitive's default properties
 */
TableHeadCell.defaultProps = {
  borderWidth: [0],
  margin: [0],
  padding: [0],
  size: [0],
}

/**
 * @name propTypes
 * @memberof TableHeadCell
 * @desc Primitive's prop type definitions
 */
TableHeadCell.propTypes = {
  ...boxModelTypes,
  ...cssTypes,
}

/** @component */
export default TableHeadCell
